
import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { I18n } from '@lingui/react';
import { t } from '@lingui/macro';
import '../../styles/core.scss';
import css from './class-group-students.scss';
import PageButton from '../../components/page-button/page-button';
import StudentList from '../../components/student-list/student-list';
import Checkbox from '../../components/checkbox/checkbox';
import DropdownSelect from '../dropdown-select/dropdown-select';
import { findItemWithIndex } from '../../helpers/utils';
import Text from './class-group-students-text';
import ConfirmationButton from '../confirmation-button/confirmation-button';

const ClassGroupStudents = ({ classList, classGroups, classId, allSelected, fromWholeClass, selectAll,
    students, selectStudents, selectClass, selectGroup, groupId, selectedStudents, handleOnRemoveFromClass,
    showConfirmationButton, unassign, handleOnConfirmButtonCancel
}) => {
    const emptyFunction = () => {};
    selectStudents = selectStudents || emptyFunction;
    selectClass = selectClass || emptyFunction;
    selectGroup = selectGroup || emptyFunction;
    unassign = unassign || emptyFunction;

    const selectedClassroom = findItemWithIndex(classList, 'id', classId);
    const selectedClassGroup = findItemWithIndex(classGroups, 'id', groupId);
    const checkBox = () => {
        if (students && students.length !== 0) {
            return (<Checkbox
                style={{}}
                data={{ type: 'plain', selected: allSelected, label: Text.selectAll }}
                callback={originalData =>
                    selectAll(!originalData.selected)}
            />);
        }
        return null;
    };

    return (
        <div className={css['class-group-students']}>
            <div className={`${css['sub-header']} page-subheader`}>
                {fromWholeClass ? checkBox() : null}
                <div className={`${css['class-group-select']} ${fromWholeClass ? css['whole-class'] : null}`}>
                    {fromWholeClass ? null :
                        (<div className={css['select-holder']}>
                            <DropdownSelect
                                rawData={classList}
                                labelProperty="name"
                                selectedIndex={selectedClassroom.indexValue}
                                onChange={(item) => { selectClass((item || {}).id); }} />
                        </div>)
                    }
                    <div className={css['select-holder']}>
                        <DropdownSelect
                            rawData={classGroups}
                            labelProperty="name"
                            selectedIndex={selectedClassGroup.indexValue}
                            onChange={(item) => { selectGroup((item || {}).id); }} />
                    </div>
                </div>
                {fromWholeClass ? null : <div className={css['select-screens']}>
                    {checkBox()}
                </div>
                }
            </div>
            <div className={css['student-list']}>
                <StudentList
                    students={students}
                    onChange={selectStudents}
                    type={Text.noStudentsAssigned}
                />
            </div>
            <div className={`${css['sub-header']} page-subheader`}>
                <I18n>
                    {({ i18n }) => (
                        <div className={css['un-assign']}>
                            <div className={showConfirmationButton ? css.none : ''}>
                                <PageButton
                                    onClick={() => { handleOnRemoveFromClass(); }}
                                    disabled={selectedStudents.length === 0}
                                    title={i18n._(t('unassignButton.title')`${Text.unassignButtonTitle}`)}
                                >
                                    {Text.removeFromClass}
                                </PageButton>
                            </div>
                            <ConfirmationButton
                                display={showConfirmationButton}
                                onCancel={handleOnConfirmButtonCancel}
                                onConfirm={unassign} />
                        </div>
                    )}
                </I18n>
            </div>
        </div>
    );
};

/**
 * Define the type of properties that can be set on this component
 */
ClassGroupStudents.propTypes = {
    classList: PropTypes.array,
    classId: PropTypes.number,
    classGroups: PropTypes.array,
    students: PropTypes.array,
    fromWholeClass: PropTypes.bool,
    allSelected: PropTypes.bool,
    selectStudents: PropTypes.func,
    selectedStudents: PropTypes.array,
    selectAll: PropTypes.func,
    selectClass: PropTypes.func,
    selectGroup: PropTypes.func,
    groupId: PropTypes.number,
    handleOnRemoveFromClass: PropTypes.func,
    showConfirmationButton: PropTypes.bool,
    unassign: PropTypes.func,
    handleOnConfirmButtonCancel: PropTypes.func
};

export default styleable(css)(ClassGroupStudents);



// WEBPACK FOOTER //
// ./components/class-group-students/class-group-students.js